//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Associative",1,0],[0,"CurveCount",1,0],[1,"DatumPlanes",0,"SelectDisplayableObjectList",0],[0,"Direction",1,0],[1,"EndCurve",0,"Section",0],[1,"Offset",0,"Expression",0],[0,"OffsetCurveCount",1,0],[0,"OffsetType",1,0],[1,"PlacementFace",0,"ScCollector",0],[1,"ReferenceCurve",0,"Section",0],[1,"StartCurve",0,"Section",0]],[],[]];
SPLM.Features.ShipDesign.TraceLinesBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.TraceLinesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.TraceLinesBuilder.TraceLineType = Object.freeze({
    "EqualSpacing" : "EqualSpacing", "Offset" : "Offset"});

export default SPLM;